import { useState, useEffect, useRef } from "react";

// jotai
import { useWindowSize } from "../lib/useWindowSize";

// api
import { getAddress } from "../api/address";

const createDateList = () => {
  let dateList = [];
  for (let i = 1; i <= 31; i++) {
    dateList.push(String(i).padStart(2, "0"));
  }
  return dateList;
};
const createMonthList = () => {
  let monthList = [];
  for (let i = 1; i <= 12; i++) {
    monthList.push(String(i).padStart(2, "0"));
  }
  return monthList;
};
const createYearList = () => {
  let yearList = [];
  const firstYear = 1930;
  let date = new Date();
  const thisYear = date.getFullYear();
  for (let i = firstYear; i <= thisYear; i++) {
    yearList.push(String(i).padStart(2, "0"));
  }
  return yearList;
};

interface InputTextProps {
  option: {
    option_name: string;
    required_optional: number;
    option_type: number;
    option_comment: string;
    option_default_value: string;
    change_value_conf: number;
    tel_flg: number;
    name_flg: number;
    company_name_flg: number;
    zip_code_flg: number;
    address_flg: number;
    space_flg: number;
    mail_address_flg: number;
    form_tel_flg: number;
    multi_text_flg: number;
    half_width_number_flg: number;
    option_select: string[];
    depend_service_names: string[];
    depend_option_name: string;
    depend_select_names: string[];
  };
  formData: { [key: string]: string | string[] };
  setFormData: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | string[] }>
  >;
  setFormTel: (value: string) => void;
  setFormEMail: (value: string) => void;
  addressOptionName: string;
}

export const InputText = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.change_value_conf !== 1 && option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap">
        <input
          disabled={option.change_value_conf === 1}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="input-text"
          value={formData[option.option_name as string]}
          inputMode={option.half_width_number_flg === 1 ? "numeric" : undefined}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (option.half_width_number_flg !== 1 || /^\d*$/.test(inputValue)) {
              setFormData((formData) => ({
                ...formData,
                [option.option_name]: inputValue,
              }));
            }
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextDate = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("2000");
  const [input2, setInput2] = useState("01");
  const [input3, setInput3] = useState("01");
  useEffect(() => {
    if (
      input1 == "2000" &&
      input2 == "01" &&
      input3 == "01" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 3
    ) {
      const option_value = formData[option.option_name as string] as string;

      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      const targetValue = input1 + "-" + input2 + "-" + input3;
      setFormTel(targetValue.replace(/-/g, ""));
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <select
          style={{ width: windowWidth > 1024 ? "135px" : "calc(33% - 25px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdDate1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput1(inputValue);
          }}
        >
          {createYearList().map((input, i) => {
            return (
              <option key={"input" + i} value={input}>
                {input}
              </option>
            );
          })}
        </select>
        <div style={{ width: "25px", textAlign: "center", marginTop: "12px" }}>
          年
        </div>
        <select
          style={{ width: windowWidth > 1024 ? "135px" : "calc(33% - 25px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdDate2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput2(inputValue);
          }}
        >
          {createMonthList().map((input, i) => {
            return (
              <option key={"input" + i} value={input}>
                {input}
              </option>
            );
          })}
        </select>
        <div style={{ width: "25px", textAlign: "center", marginTop: "12px" }}>
          月
        </div>
        <select
          style={{ width: windowWidth > 1024 ? "135px" : "calc(33% - 25px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdDate3"
          value={input3}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput3(inputValue);
          }}
        >
          {createDateList().map((input, i) => {
            return (
              <option key={"input" + i} value={input}>
                {input}
              </option>
            );
          })}
        </select>
        <div style={{ width: "25px", textAlign: "center", marginTop: "12px" }}>
          日
        </div>
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputMultiText = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap">
        <textarea
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="input-text"
          value={formData[option.option_name as string]}
          onChange={async (e) => {
            setFormData((formData) => ({
              ...formData,
              [option.option_name]: e.target.value,
            }));
          }}
          rows={4}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextTel = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 3
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      const targetValue = input1 + "-" + input2 + "-" + input3;
      setFormTel(targetValue.replace(/-/g, ""));
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          -
        </div>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          -
        </div>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel3"
          value={input3}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextFormTel = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 3
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      const targetValue = input1 + "-" + input2 + "-" + input3;
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          -
        </div>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          -
        </div>
        <input
          style={{ width: windowWidth > 1024 ? "150px" : "calc(33% - 10px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdTel3"
          value={input3}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextName = (props: InputTextProps) => {
  const { option, formData, setFormData } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 2
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const targetValue = input1 + " " + input2;
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdName1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput1(inputValue);
          }}
        />
        <div
          style={{ width: "10px", textAlign: "center", marginTop: "12px" }}
        ></div>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdName2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput2(inputValue);
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextZipCode = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: zipCode,
      }));
      const address = await getAddress(zipCode);
      setFormData((formData) => ({
        ...formData,
        [addressOptionName]: address,
        [option.option_name]: zipCode,
      }));
    }

    if (
      input1 == "" &&
      input2 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 2
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const targetValue = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(targetValue);
      } else {
        setFormData((formData) => ({
          ...formData,
          [option.option_name]: targetValue,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          maxLength={3}
          style={{
            width: windowWidth > 1024 ? "232.5px" : "calc(50% - 7.5px)",
          }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdZipCode1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          -
        </div>
        <input
          maxLength={4}
          style={{
            width: windowWidth > 1024 ? "232.5px" : "calc(50% - 7.5px)",
          }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdZipCode2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextMailAddress = (props: InputTextProps) => {
  const { option, formData, setFormData, setFormEMail } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 2
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const targetValue = input1 + "@" + input2;
      setFormEMail(targetValue.replace(/-/g, ""));
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdName1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput1(inputValue);
          }}
        />
        <div style={{ width: "15px", textAlign: "center", marginTop: "12px" }}>
          @
        </div>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdName2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput2(inputValue);
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputTextSpace = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      formData[option.option_name as string] &&
      formData[option.option_name as string] != "" &&
      formData[option.option_name as string].length !== 2
    ) {
      const option_value = formData[option.option_name as string] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const targetValue = input1 + " " + input2;
      setFormData((formData) => ({
        ...formData,
        [option.option_name]: targetValue,
      }));
    }
  }, [input1, input2]);
  return (
    <div className="input_block">
      <label>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap" style={{ display: "flex" }}>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdSpace1"
          value={input1}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput1(inputValue);
          }}
        />
        <div
          style={{ width: "10px", textAlign: "center", marginTop: "12px" }}
        ></div>
        <input
          style={{ width: windowWidth > 1024 ? "235px" : "calc(50% - 5px)" }}
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          id="textFieldIdSpace2"
          value={input2}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInput2(inputValue);
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};

export const InputPullDown = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const customerInfoList = formData[option.option_name] as string[];
  return (
    <>
      <div className="input_block">
        <label style={{ margin: "0px" }}>
          {option.option_name}
          {option.required_optional == 1 ? (
            <span className="require">必須</span>
          ) : null}
        </label>
      </div>
      {option.option_select.map((option_select) => {
        return (
          <div className="checkbox_block">
            <span className="wpcf7-form-control-wrap" data-name="checkbox-664">
              <span className="wpcf7-form-control wpcf7-acceptance">
                <span className="wpcf7-list-item">
                  <label>
                    <input
                      type="radio"
                      value={option_select}
                      style={{ width: "inherit" }}
                      checked={formData[option.option_name] === option_select}
                      onClick={() => {
                        setFormData((formData) => ({
                          ...formData,
                          [option.option_name]: option_select,
                        }));
                      }}
                    />
                    <span className="wpcf7-list-item-label">
                      {option_select}
                    </span>
                  </label>
                </span>
              </span>
            </span>
          </div>
        );
      })}
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </>
  );
};

export const InputCheckBox = (props: InputTextProps) => {
  const {
    option,
    formData,
    setFormData,
    setFormTel,
    setFormEMail,
    addressOptionName,
  } = props;
  const customerInfoList = formData[option.option_name] as string[];
  return (
    <>
      <div className="input_block">
        <label style={{ margin: "0px" }}>
          {option.option_name}
          {option.required_optional == 1 ? (
            <span className="require">必須</span>
          ) : null}
        </label>
      </div>
      {option.option_select.map((option_select) => {
        return (
          <div className="checkbox_block">
            <span className="wpcf7-form-control-wrap" data-name="checkbox-664">
              <span className="wpcf7-form-control wpcf7-acceptance">
                <span className="wpcf7-list-item">
                  <label>
                    <input
                      type="checkbox"
                      value={option_select}
                      style={{ width: "inherit" }}
                      checked={
                        customerInfoList.findIndex(
                          (_option_select) => _option_select === option_select
                        ) > -1
                      }
                      onClick={() => {
                        let _customerInfoList = customerInfoList.concat();
                        if (
                          customerInfoList.findIndex(
                            (_option_select) => _option_select === option_select
                          ) > -1
                        ) {
                          _customerInfoList = _customerInfoList.filter(
                            (_option_select) => _option_select !== option_select
                          );
                        } else {
                          _customerInfoList.push(option_select);
                        }
                        setFormData((formData) => ({
                          ...formData,
                          [option.option_name]: _customerInfoList,
                        }));
                      }}
                    />
                    <span className="wpcf7-list-item-label">
                      {option_select}
                    </span>
                  </label>
                </span>
              </span>
            </span>
          </div>
        );
      })}
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </>
  );
};

export const InputPicuture = (props: {
  option: {
    option_name: string;
    required_optional: number;
    option_type: number;
    option_comment: string;
    option_default_value: string;
    change_value_conf: number;
    tel_flg: number;
    name_flg: number;
    company_name_flg: number;
    zip_code_flg: number;
    address_flg: number;
    space_flg: number;
    mail_address_flg: number;
    form_tel_flg: number;
    multi_text_flg: number;
    half_width_number_flg: number;
    option_select: string[];
    depend_service_names: string[];
    depend_option_name: string;
    depend_select_names: string[];
  };
  formData: { [key: string]: string | string[] };
  setFormData: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | string[] }>
  >;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
}) => {
  const { option, formData, setFormData, postPictures, setPostPicture } = props;
  return (
    <div className="input_block">
      <label style={{ margin: "0px" }}>
        {option.option_name}
        {option.required_optional == 1 ? (
          <span className="require">必須</span>
        ) : null}
      </label>
      <span className="wpcf7-form-control-wrap">
        <input
          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required name"
          style={{
            border: "unset",
          }}
          id="textFieldPicture"
          type="file"
          onChange={(event_file: React.ChangeEvent<HTMLInputElement>) => {
            if (event_file.target.files && event_file.target.files.length > 0) {
              const file = event_file.target.files[0];
              const updatedPostPictures = {
                ...postPictures,
                [option.option_name as string]: file,
              };
              setPostPicture(updatedPostPictures);
            }
          }}
        />
      </span>
      {option.option_comment !== "" ? (
        <span className="helperText">{option.option_comment}</span>
      ) : null}
    </div>
  );
};
